import {
  anAggregationRuleFunction,
  mockAggregationRuleFunctionsOperationQuery,
} from '__generated__';

export const handlers = [
  mockAggregationRuleFunctionsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        aggregationRuleFunctions: [
          anAggregationRuleFunction({
            name: 'avg',
          }),
          anAggregationRuleFunction({
            name: 'count',
          }),
          anAggregationRuleFunction({
            name: 'count_distinct',
          }),
          anAggregationRuleFunction({
            name: 'first',
          }),
          anAggregationRuleFunction({
            name: 'last',
          }),
          anAggregationRuleFunction({
            name: 'max',
          }),
          anAggregationRuleFunction({
            name: 'min',
          }),
          anAggregationRuleFunction({
            name: 'sum',
          }),
        ],
      })
    );
  }),
];
